import React, { createContext, useContext, useState } from 'react';

const VideoContext = createContext();

export const useVideo = () => {
    const context = useContext(VideoContext);
    if (!context) {
        return {
            isVideoPlaying: false,
            isVideoFullscreen: false,
            setIsVideoPlaying: () => console.warn('⚠️ VideoContext non initialisé'),
            setIsVideoFullscreen: () => console.warn('⚠️ VideoContext non initialisé')
        };
    }
    return context;
};

export const VideoProvider = ({ children }) => {
    const [isVideoPlaying, setIsVideoPlayingInternal] = useState(false);
    const [isVideoFullscreen, setIsVideoFullscreenInternal] = useState(false);

    // Wrappers avec logs
    const setIsVideoPlaying = (value) => {
        setIsVideoPlayingInternal(value);
    };

    const setIsVideoFullscreen = (value) => {
        setIsVideoFullscreenInternal(value);
    };

    return (
        <VideoContext.Provider value={{
            isVideoPlaying,
            setIsVideoPlaying,
            isVideoFullscreen,
            setIsVideoFullscreen
        }}>
            {children}
        </VideoContext.Provider>
    );
};

export default VideoProvider;